import React from 'react';

import { SVGComponentProps } from './svg.types';

const HeadingThreeSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" fill="white" />
        <path
          d="M3 10.9048H4.33V8.00952H7.54V10.9048H8.88V4.09524H7.54V6.99048H4.33V4.09524H3V10.9048Z"
          fill="#55585E"
        />
        <path
          d="M12.7298 11C14.3698 11 15.4098 10.219 15.4098 8.9619C15.4098 8.05714 14.8598 7.49524 14.0298 7.31429C14.7198 7.06667 15.1898 6.6 15.1898 5.82857C15.1898 4.81905 14.3198 4 12.8298 4C11.2998 4 10.3698 4.90476 10.2998 6.08571H11.4798C11.5598 5.4 12.0498 4.9619 12.8098 4.9619C13.5498 4.9619 13.9198 5.37143 13.9198 5.92381C13.9198 6.5619 13.5498 6.92381 12.7298 6.92381H12.2198V7.82857H12.7698C13.6398 7.82857 14.0598 8.2 14.0598 8.94286C14.0598 9.61905 13.6298 10.0476 12.6998 10.0476C11.7398 10.0476 11.3198 9.51429 11.2498 8.8H10.0398C10.0998 10.1048 11.0298 11 12.7298 11Z"
          fill="#55585E"
        />
        <rect x="3" y="15" width="18" height="1" fill="#BCBEC2" />
        <rect x="3" y="17" width="18" height="1" fill="#BCBEC2" />
        <rect x="3" y="19" width="10" height="1" fill="#BCBEC2" />
        <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" stroke="#D5D7DD" />
      </svg>
    </span>
  );
};

export default HeadingThreeSVG;
